import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import SitePage from '../components/SitePage';

class SiteOfAgent extends Component {
  render() {
    const pageProps = {
      fetchDictionary: (dictType, callback) => {
        DataFetcher.distionary(dictType, {
          success: callback
        })
      },
      fetchDistrict: (params, callback) => {
        DataFetcher.districtTree({
          success: callback
        })
      },
      fetchSites: (params, callback) => {
        DataFetcher.querySite(params, {
          success: callback
        })
      },
      createSite: (params, callback, completed) => {
        DataFetcher.createSite(params, {
          success: callback,
          completed
        })
      },
      updateSite: (params, callback, completed) => {
        DataFetcher.updateSite(params, {
          success: callback,
          completed
        })
      },
      shutdownTime: (params, callback, completed) => {
        DataFetcher.updateSiteShutdownTime(params, {
          success: callback,
          completed
        })
      }
    }

    return <SitePage {...pageProps}/>
  }
}

export default SiteOfAgent;


// WEBPACK FOOTER //
// ./src/modules/SiteOfAgent.js